module.exports = __webpack_public_path__ + "img/about-card-03.8301d0f7.png";